// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"7342c0fc","927":"92ae2725"}[chunkId] + ".css";
};